import i18n from "@/i18n";
import common from "@assets/js/common";
import { getDataProfitTaker } from "@services/alert/profit-taker";
import dayjs from "dayjs";

const state = {
    autoRefreshTimeOffset: 1,
    loading: false,
    alertData: [],
    alertHeader: [
        { text: i18n.t("common.table.login"), value: "login", align: "left" },
        {
            text: i18n.t("common.table.name"),
            value: "name",
            align: "left",
            sortable: false,
        },
        { text: i18n.t("common.table.symbol"), value: "symbol", align: "left" },
        { text: "Book", value: "books", align: "left" },
        {
            text: i18n.t("common.table.profitEOD"),
            value: "profit_closed_eod",
            align: "right",
        },
        {
            text: i18n.t("common.table.triggerTime"),
            value: "trigger_time",
            width: 170,
            align: "left",
        },
    ],
    alertDataAmount: 0,
    csvHeader: {
        Login: "login",
        Symbol: "symbol",
        Books: "books",
        "Profit EOD": "profit_closed_eod",
        "Trigger Time": "trigger_time",
        "Server Name": "server_name",
        "Profit Threshold": "profit_threshold",
    },
    selectedDate: null,
};

const actions = {
    /**
     * Fetch large volume data
     * @param   {[type]}  commit  [commit description]
     * @param   {[type]}  data    [data description]
     * @return  {[type]}          [return description]
     */
    getDataProfitTakerAction({ commit }, data) {
        commit("UPDATE_LOADING", true);
        getDataProfitTaker(data).then((res) => {
            res.data.data.forEach((item) => {
                item["books"] = item["books"].replace(/[[\]]/g, "");
            });
            commit("UPDATE_ALERT_DATA", res.data.data);
            commit("UPDATE_AMOUNT", res.data.count);
            commit("UPDATE_LOADING", false);
        });
    },
    processProfitTaker({ commit }, data) {
        const minimumAcceptableTime = dayjs(
            common.getMT4Time().format("YYYY-MM-DD")
        ).unix();

        if (
            state.selectedDate >= minimumAcceptableTime &&
            data.trigger_time >= minimumAcceptableTime
        ) {
            data.books = data.books.replace(/[[\]]/g, "");
            const exist = state.alertData.find(
                (item) =>
                    item.login == data.login &&
                    item.books == data.books &&
                    item.symbol == data.symbol &&
                    item.locking_position == data.locking_position &&
                    item.trigger_time == data.trigger_time
            );
            if (!exist) {
                data["new"] = true;
                commit("UPDATE_ALERT_DATA", [data, ...state.alertData]);
            }
        }
    },
};

const mutations = {
    /**
     * Update monitor data
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_MONITOR_DATA(state, data) {
        state.monitorData = data;
    },
    /**
     * Update alert data
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_ALERT_DATA(state, data) {
        state.alertData = data;
    },
    /**
     * Update loading
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_LOADING(state, data) {
        state.loading = data;
    },
    UPDATE_ALERT_HEADER(state, data) {
        state.alertHeader = data;
    },
    UPDATE_SELECTED_DATE(state, data) {
        state.selectedDate = dayjs(data).unix();
    },
    UPDATE_AMOUNT(state, data) {
        state.alertDataAmount = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
